import { render, staticRenderFns } from "./DataPrivacyPage.vue?vue&type=template&id=1cda3e66&scoped=true&"
var script = {}
import style0 from "./DataPrivacyPage.vue?vue&type=style&index=0&id=1cda3e66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cda3e66",
  null
  
)

export default component.exports